import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import LoginNavbar from './LoginNavbar.tsx';
import LoginCredentials from './LoginCredentials.tsx';
import LoginFeatures from './LoginFeatures.tsx';
import LoginFooter from './LoginFooter.tsx';
import LoginBrandsCarrusel from './LoginBrandsCarrusel.tsx';
import LoginDiscounts from './LoginDiscounts.tsx';
import LoginImagesCarrusel from './LoginImagesCarrusel.tsx';
import useLisualWidget from '../../utils/useLisualWidget';

const Login = () => {
  const [buyButtonTouched, setBuyButtonTouched] = useState(false);
  const [showScrollTopButton, setShowScrollTopButton] = useState(false); 

  const scrollToFeatures = () => {
    const featuresElement = document.getElementById("features");
    if (featuresElement) {
      featuresElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
  };

  const handleScroll = () => {
    
    if (window.scrollY > 300) {
      setShowScrollTopButton(true);
    } else {
      setShowScrollTopButton(false);
    }
  };

  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Widget de ayuda. En el login no hay sesión: si venía de una, el hook cierra la del widget.
  useLisualWidget();

  return (
    <>
      <LoginNavbar />
      <LoginCredentials
        buyButtonTouched={buyButtonTouched}
        scrollToFeatures={() => {
          setBuyButtonTouched(true);
          scrollToFeatures();
        }}
      />
      <LoginDiscounts />
      <LoginFeatures id="features" className="scroll-mt-12" />
      <LoginBrandsCarrusel />
      <LoginImagesCarrusel />
      {/*<LoginFooter />*/}
      {showScrollTopButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-4 right-4 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-opacity duration-300 z-50"
          aria-label="Ir arriba"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
          </svg>
        </button>
      )}
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
    </>
  );
};

export default Login;
